import React from 'react';
import { Icon } from './Icon.tsx';

const NativeButton = 'button';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    icon: string;
    variant?: 'ghost' | 'subtle' | 'danger' | 'danger-subtle' | 'primary' | 'secondary' | 'outline' | 'blue' | 'purple' | 'success' | 'warning';
    size?: 'xs' | 'sm' | 'md' | 'lg';
    label?: string;
    visibility?: 'always' | 'group-hover';
}

const variantClasses = {
    ghost: 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-800',
    subtle: 'text-gray-500 hover:text-primary hover:bg-primary/10',
    danger: 'text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20',
    'danger-subtle': 'text-red-500 hover:text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20',
    primary: 'text-primary hover:text-primary-content hover:bg-primary',
    secondary: 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-700',
    outline: 'border border-primary text-primary hover:bg-primary hover:text-primary-content',
    blue: 'bg-blue-600 text-white hover:bg-blue-700 shadow-sm shadow-blue-500/30 font-bold',
    purple: 'bg-purple-600 text-white hover:bg-purple-700 shadow-sm shadow-purple-500/30 font-bold',
    success: 'text-gray-400 hover:text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/20',
    warning: 'text-gray-400 hover:text-amber-600 hover:bg-amber-50 dark:hover:bg-amber-900/20',
};

const sizeClasses = {
    xs: 'p-0',
    sm: 'p-1',
    md: 'p-1.5',
    lg: 'p-2'
};

const iconSizeMap = {
    xs: 'xs' as const,
    sm: 'sm' as const,
    md: 'md' as const,
    lg: 'lg' as const
};

export const IconButton: React.FC<IconButtonProps> = ({ 
    icon, 
    variant = 'ghost', 
    size = 'md',
    label,
    className = '',
    disabled,
    type = 'button',
    visibility = 'always',
    ...props 
}) => (
        <NativeButton
            className={`focus-ring rounded-lg transition-colors ${variantClasses[variant]}
                ${sizeClasses[size]}
                ${visibility === 'group-hover' ? 'opacity-0 transition-opacity group-hover:opacity-100' : ''}
                ${disabled ? 'cursor-not-allowed opacity-50' : ''}
                ${className}
            `}
            disabled={disabled}
            aria-label={label}
            title={label}
            type={type}
            {...props}
        >
            <Icon name={icon} size={iconSizeMap[size]} />
        </NativeButton>
    );














